import { assert_number_gt_0, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '../../common/DTO__base';
import { IDatabaseEntity } from './IDatabaseEntity';

//todo: rename to DTO_DatabaseEntity
export abstract class DTO__database_entity extends DTO__base implements IDatabaseEntity {
  /*
   * STATIC METHODS
   */
  static sort_by_created_at_newest_first(a: DTO__database_entity, b: DTO__database_entity): number {
    return b.created_at - a.created_at;
  }

  static sort_by_created_at_oldest_first(a: DTO__database_entity, b: DTO__database_entity): number {
    return a.created_at - b.created_at;
  }

  static sort_by_updated_at_newest_first(a: DTO__database_entity, b: DTO__database_entity): number {
    return b.updated_at - a.updated_at;
  }

  static sort_by_id(a: DTO__database_entity, b: DTO__database_entity): number {
    return b._id.localeCompare(a._id);
  }

  static list_to_map_by_id<T extends DTO__database_entity>(list: T[]): Map<string, T> {
    let out: Map<string, T> = new Map();

    for (let item of list) {
      out.set(item._id, item);
    }

    return out;
  }

  /*
   * FIELDS
   */
  _id!: string;

  created_at!: number;
  updated_at!: number;

  /*
   * METHODS
   */

  assert_standard_fields() {
    assert_string_object_id(this._id);

    assert_number_gt_0(this.created_at);
    assert_number_gt_0(this.updated_at);
  }
}
